// ECharts needs colour literals, so the chart palette is the one place a value is
// duplicated between SCSS and JavaScript. src/assets/sass/_tokens.scss stays the
// human source of truth.
export const CHART_SERIES = [
  "#174569",
  "#1b75ba",
  "#28aae1",
  "#77d9f7",
  "#fab15b",
  "#fa8d41",
  "#81a872",
  "#628b45",
]

export const CHART_PRIMARY = "#1b75ba"
export const AXIS_LINE = "#e3edf4"
export const AXIS_LABEL_X = "#949494"
export const AXIS_LABEL_Y = "#b0bec5"
export const SPLIT_LINE = "#eef4f8"
export const AREA_GRADIENT_FROM = "rgba(40,170,225,.20)"
export const AREA_GRADIENT_TO = "rgba(40,170,225,.02)"
